import { WHATSAPP_URL, IMAGES, LOGO_URL } from "@/config/site";

const Hero = () => {
  return (
    <header
      id="top"
      data-testid="hero-section"
      className="relative pt-24 pb-28 px-6 border-b border-stone-800 overflow-hidden bg-gradient-to-b from-[#0a1128] to-[#050914]"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(217,119,6,0.12),transparent_70%)] pointer-events-none"></div>
      <div className="max-w-7xl mx-auto relative z-10 flex justify-center mb-14">
        <img
          src={LOGO_URL}
          alt="BGNZN — The Bourganization Institute"
          data-testid="hero-logo"
          className="h-28 sm:h-36 lg:h-44 w-auto invert hue-rotate-180 drop-shadow-[0_0_36px_rgba(217,119,6,0.45)] reveal-entry"
        />
      </div>
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center relative z-10">
        <div className="lg:col-span-7 space-y-6 reveal-entry">
          <div className="mono-tag text-xs tracking-wider uppercase text-amber-400/90 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-amber-400 pulse-glow"></span>
            Henderson &amp; Las Vegas, Nevada · Global Autonomous League
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-stone-100 leading-[1.08] display-serif">
            Self-Sufficiency Through Sovereign Knowledge
          </h1>
          <p className="text-lg text-stone-300 max-w-2xl leading-relaxed">
            We are a 501(c)(6) non-profit business league dedicated to empowering individuals and
            businesses to live and operate with complete autonomy. Operating on trade, barter, and
            member dues, we equip you with real vocational and institutional mastery free of charge.
          </p>
          <div className="pt-2">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-cta"
              className="inline-flex items-center justify-center px-6 py-3.5 rounded bg-amber-500 hover:bg-amber-400 text-stone-950 font-bold text-base transition-colors shadow-lg hover:shadow-amber-500/20"
            >
              Connect on WhatsApp
            </a>
          </div>
          <div
            data-testid="hero-metrics"
            className="pt-6 grid grid-cols-3 gap-4 border-t border-stone-800/80 text-xs text-stone-400"
          >
            <div>
              <span className="block text-stone-200 font-semibold text-sm">6+ Hours Daily</span>
              Direct mentorship dedication
            </div>
            <div>
              <span className="block text-stone-200 font-semibold text-sm">Zero Tuition</span>
              Free educational programs
            </div>
            <div>
              <span className="block text-stone-200 font-semibold text-sm">Private Reserve</span>
              Nonmarketable exchange tier
            </div>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="relative rounded-2xl border border-stone-700/80 p-2 bg-stone-900/80 shadow-2xl backdrop-blur">
            <div className="aspect-[4/3] rounded-xl border border-amber-900/40 relative overflow-hidden">
              <img
                src={IMAGES.hero.url}
                alt={IMAGES.hero.alt}
                data-testid="hero-image"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/50 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
